import { render, staticRenderFns } from "./AuditTrailSideMenu.vue?vue&type=template&id=58f0fa4a"
import script from "./AuditTrailSideMenu.vue?vue&type=script&lang=js"
export * from "./AuditTrailSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f0fa4a')) {
      api.createRecord('58f0fa4a', component.options)
    } else {
      api.reload('58f0fa4a', component.options)
    }
    module.hot.accept("./AuditTrailSideMenu.vue?vue&type=template&id=58f0fa4a", function () {
      api.rerender('58f0fa4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audittrail/AuditTrailSideMenu.vue"
export default component.exports